import ReactMarkdown from 'react-markdown';

interface CoachMarkdownProps {
  content: string;
}

/**
 * Renders coach message content as styled markdown.
 * Supports bold, line breaks, paragraphs, and lists.
 */
export function CoachMarkdown({ content }: CoachMarkdownProps) {
  return (
    <ReactMarkdown
      components={{
        p: ({ children }) => (
          <p className="text-sm leading-relaxed mb-2 last:mb-0">{children}</p>
        ),
        strong: ({ children }) => (
          <strong className="font-semibold text-white">{children}</strong>
        ),
        ul: ({ children }) => (
          <ul className="text-sm leading-relaxed list-disc list-outside pl-5 mb-2 last:mb-0 space-y-1 [&>li]:pl-0.5">{children}</ul>
        ),
        ol: ({ children }) => (
          <ol className="text-sm leading-relaxed list-decimal list-outside pl-5 mb-2 last:mb-0 space-y-1 [&>li]:pl-0.5">{children}</ol>
        ),
        li: ({ children }) => (
          <li className="text-sm leading-relaxed">{children}</li>
        ),
        h3: ({ children }) => (
          <p className="text-sm font-semibold text-white mb-1">{children}</p>
        ),
      }}
    >
      {content}
    </ReactMarkdown>
  );
}
